<template>
  <div class="row">
    <div class="col-md-8 col-sm-12">
      <b-form-select
        :id="domId"
        :options="timeOfWorkValues"
        class="form-control"
        @input="setWorkTime(number, $event)"
        :value="timeOfWork"
      />
    </div>

    <div class="col-md-4 col-sm-12 mt-2">
      <button
        v-if="number === 0"
        style="width: 70%"
        type="button"
        class="btn btn-primary btn-primary-blue"
        @click="addWorkTime"
      >Добавить
      </button>
      <button
        v-else
        style="width: 70%"
        type="button"
        class="btn btn-default"
        @click="removeWorkTime(number)"
      >Удалить
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    number: {
      type: Number
    },
    timeOfWorkValues: {
      type: Object
    },
    timeOfWork: {
      type: Number
    },
    addWorkTime: {
      type: Function
    },
    removeWorkTime: {
      type: Function
    },
    setWorkTime: {
      type: Function
    }
  },

  data () {
    return {
      timeOfWorkId: {
        type: Number
      }
    }
  },

  created () {
    this.timeOfWorkIdComputed = Number(this.timeOfWork)
  },

  computed: {
    domId: function () {
      return `work-time-${this.number}`
    },
    timeOfWorkIdComputed: {
      set: function (value) {
        this.timeOfWorkId = Number(value)
        this.setWorkTime(this.number, Number(value))
      },
      get: function () {
        return this.timeOfWorkId
      }
    }
  }
}
</script>
